import React from 'react';
import {injectIntl} from "react-intl";
import {Button, Divider} from "antd";
import {withAuthorization} from "../../services/Authorization";
import Storage from "../../services/Storage";
import connect from "react-redux/es/connect/connect";
import LabelEncoder from "./LabelEncoder";
import UploadPictures from "../common/upload/UploadPictures";
import {SpinnerModal} from "../../public/components/SpinnerModal";

const supportedLanguages = ['en', 'de', 'fr', 'nl'];

const MAX_DEALERSHIP_PHOTOS = 5;
const MAX_BODYSHOP_PHOTOS = 5;
const MAX_SAFEBOX_PHOTOS = 5;

class Attachments extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fileList: this.initialFileList(),
      outdatedFiles: []
    }
  }

  initialFileList = () => {
    return {
      'dealership-photos': [],
      'bodyshop-photos': [],
      'safebox-photos': []
    };
  };

  componentDidMount() {
    this.props.dispatchFetchPictures();
  }

  componentWillReceiveProps = (nextProps) => {
    const {fetchPictures:{pictures}} = nextProps;

    if (this.props.fetchPictures !== nextProps.fetchPictures && pictures) {
      const {safebox=[]} = pictures;
      const dealershipPhotos = (pictures.dealershipPhotos || []).map(a => ({uid: a.key}))
      const bodyshopPhotos = (pictures.bodyshopPhotos || []).map(a => ({uid: a.key}))
      const safeboxPhotos = (pictures.safeboxPhotos || []).map(a => ({uid: a.key}))
      this.setState({dealershipPhotos, bodyshopPhotos, safeboxPhotos, fileList: this.initialFileList(), keySafeInfo: safebox.description});
    }
  };

  save = () => {
    const {fileList} = this.state;
    const {'dealership-photos':dealershipPhotos, 'bodyshop-photos':bodyshopPhotos, 'safebox-photos':safeboxPhotos} = fileList;

    const form = new FormData();
    dealershipPhotos && dealershipPhotos.forEach((file) => {
      form.append('dealership-photos', file);
    });
    bodyshopPhotos && bodyshopPhotos.forEach((file) => {
      form.append('bodyshop-photos', file);
    });
    safeboxPhotos && safeboxPhotos.forEach((file) => {
      form.append('safebox-photos', file);
    });
    if (this.state.keySafeInfo) {
      form.append('safeBoxDescription.en', this.state.keySafeInfo.en);
      form.append('safeBoxDescription.fr', this.state.keySafeInfo.fr);
      form.append('safeBoxDescription.de', this.state.keySafeInfo.de);
      form.append('safeBoxDescription.nl', this.state.keySafeInfo.nl);
    }
    form.append('outdatedFiles', this.state.outdatedFiles);
    this.props.dispatchSavePictures(form);
  };

  handleFileRemove = (file, category) => {
    if (file.originFileObj) {
      // it means the file has not been uploaded yet
      const fileList = this.state.fileList;
      fileList[category] = fileList[category].filter(f => f.uid !== file.uid);
      this.setState({fileList});

      return;
    }
    this.setState(({outdatedFiles})=>({outdatedFiles:[...outdatedFiles, file.uid]}));
  };

  handleDealerChange = ({fileList}) => {
    this.setState({dealershipPhotos: fileList})
  };

  handleBodyshopChange = ({fileList}) => {
    this.setState({bodyshopPhotos: fileList})
  };

  handleSafeboxChange = ({fileList}) => {
    this.setState({safeboxPhotos: fileList})
  };

  handleBeforeUpload = (file, category) => {
    this.setState((prevstate) => {
      const {fileList} = prevstate;
      fileList[category] = [...fileList[category], file];
      return {
        fileList,
        [category]: [...fileList, file],
      }
    });
    return false;
  };

  onValidateKeySafe = (values) => {
    let {keySafeInfo = {}} = this.state;

    supportedLanguages.forEach(lg => {
      keySafeInfo[lg] = values[lg];
    });
    this.setState({keySafeInfo});
  };

  removeKeySafe = () => {
    this.setState({keySafeInfo: undefined});
  };

  renderKeySafeInfo = () => {
    const {intl, intl: {formatMessage}} = this.props;
    const {keySafeInfo} = this.state;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';

    if (!keySafeInfo) {
      return null;
    }
    return (
      <div>
        <span>{formatMessage({id: `${intl.locale}`})} : {keySafeInfo[intl.locale]}</span>
          {canWrite &&
            <a className={"smaller"} onClick={this.removeKeySafe}>&ensp;{formatMessage({id:'action.delete'})}</a>
          }
      </div>
    )
  };

  render() {
    const {intl:{formatMessage}, loading, fetchPictures} = this.props;
    const {dealershipPhotos=[], bodyshopPhotos=[], safeboxPhotos=[]} = this.state;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';
    const error = fetchPictures && fetchPictures.error && fetchPictures.error.content;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.attachments.title'})}
          </h2>
          {canWrite &&
            <div className="box-heading__button">
              <button onClick={this.save} type="primary" className="btn btn-sm btn-primary">
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          }
        </header>
        {
          <div className="box__body">
            <SpinnerModal visible={loading}/>
            <div className="row">
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'section.attachments.dealership.title'})}</h3>
                  <UploadPictures files={dealershipPhotos} beforeUpload={(file)=>this.handleBeforeUpload(file, 'dealership-photos')} onRemove={(e) => this.handleFileRemove(e, 'dealership-photos')}
                                  onChange={this.handleDealerChange} showUploadList={{showRemoveIcon: canWrite, showPreviewIcon: true}} error={error && error['dealership-photos']}
                                  allowUpload={canWrite && dealershipPhotos.length < MAX_DEALERSHIP_PHOTOS}/>
              </div>
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'section.attachments.bodyshop.title'})}</h3>
                <UploadPictures files={bodyshopPhotos} beforeUpload={(file)=>this.handleBeforeUpload(file, 'bodyshop-photos')} onRemove={(e) => this.handleFileRemove(e, 'bodyshop-photos')}
                                onChange={this.handleBodyshopChange} showUploadList={{showRemoveIcon: canWrite, showPreviewIcon: true}} error={error && error['bodyshop-photos']}
                                allowUpload={canWrite && bodyshopPhotos.length < MAX_BODYSHOP_PHOTOS}/>
              </div>
            </div>
            <Divider/>
            <div className="row">
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'section.attachments.safebox.title'})}</h3>
                <UploadPictures files={safeboxPhotos} beforeUpload={(file)=>this.handleBeforeUpload(file, 'safebox-photos')} onRemove={(e) => this.handleFileRemove(e, 'safebox-photos')}
                                onChange={this.handleSafeboxChange} showUploadList={{showRemoveIcon: canWrite, showPreviewIcon: true}} error={error && error['safebox-photos']}
                                allowUpload={canWrite && safeboxPhotos.length < MAX_SAFEBOX_PHOTOS}/>
              </div>
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'section.attachments.keySafe.info'})}</h3>

                <ul className="list">
                  {this.renderKeySafeInfo()}

                  {canWrite &&
                    <LabelEncoder keys={supportedLanguages} onValidate={this.onValidateKeySafe} values={this.state.keySafeInfo}>
                    <li className="list__footer">
                      <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                        <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                          <use xlinkHref="#icon-plus"/>
                        </svg>
                        <strong>{formatMessage({id:'section.attachments.setKeySafeInfo'})}</strong>
                      </Button>
                    </li>
                  </LabelEncoder>}
                </ul>
              </div>
            </div>
          </div>
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchPictures: state.fetchPictures,
  loading: state.fetchPictures.loading
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchPictures: () => dispatch({type: 'FETCH_PICTURES.REQUEST'}),
  dispatchSavePictures: (body) => dispatch({type: 'SAVE_PICTURES.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(Attachments), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/dealership/Attachments.js